/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Phoenix | v1
 * OpenAPI spec version: 1.0.0
 */

export type ChainMutationKind = typeof ChainMutationKind[keyof typeof ChainMutationKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChainMutationKind = {
  Add: 'Add',
  AddConnected: 'AddConnected',
  Remove: 'Remove',
  Flip: 'Flip',
} as const;
